module.exports = __webpack_public_path__ + "static/media/arrow_right_alt-24px.361453dd.svg";